module.exports = __webpack_public_path__ + "static/media/RaspberryPi.473fd7fb.png";